var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTearSheetsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Tear Sheets",
    clipPath: "url(#clip0_395_8217)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.3334 12.5H7.50004V10.8333H13.3334V12.5ZM15.8334 9.16666H7.50004V7.5H15.8334V9.16666ZM15.8334 5.83333H7.50004V4.16666H15.8334V5.83333ZM2.50004 4.16666V17.5H15.8334V19.1667H2.50004C2.05801 19.1667 1.63409 18.9911 1.32153 18.6785C1.00897 18.3659 0.833374 17.942 0.833374 17.5V4.16666H2.50004ZM17.5 0.833328C17.9421 0.833328 18.366 1.00892 18.6786 1.32148C18.9911 1.63404 19.1667 2.05797 19.1667 2.49999V14.1667C19.1667 15.0917 18.425 15.8333 17.5 15.8333H5.83337C5.39135 15.8333 4.96742 15.6577 4.65486 15.3452C4.3423 15.0326 4.16671 14.6087 4.16671 14.1667V2.49999C4.16671 1.57499 4.90837 0.833328 5.83337 0.833328H17.5ZM5.83337 2.49999V14.1667H17.5V2.49999H5.83337Z",
    fill: "#5E5E5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_395_8217"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTearSheetsIcon);
export default __webpack_public_path__ + "static/media/TearSheetsIcon.155ddc8f636ff5d53a106f1a5814a368.svg";
export { ForwardRef as ReactComponent };